import React, { Component } from 'react';
import { Col, Row, Form, FormGroup, ControlLabel, FormControl, Checkbox, Button, ButtonGroup, Label } from 'react-bootstrap';
import Modal from '../lib/modal-shim';
import toastr from 'toastr';
import { HeaderBar } from '../components/HeaderBar.js';

import { CollapsablePanel } from '../components/CollapsablePanel';
import { MapCreatorPanel } from '../components/MapCreatorPanel';
import { ContactList } from '../components/ContactList'



export class LogisticCreator extends Component {

    addRouteToList = () => {
      let _r = this.state.route;

      _r._id = Math.round(Math.random()*100);
      _r.polyline.remove();
      _r.polyline = null;
      _r.from.marker.remove();
      _r.from.marker = null;
      _r.to.marker.remove();
      _r.to.marker = null;

      _r.from.name = _r.from.address;
      _r.to.name = _r.to.address;

      this.props.onAddRoute(_r);

      toastr.info('You added route from '+_r.from.name+' to '+_r.to_name+' for Truk id: ' + _r.truck );
      _r = this.resetRoute();
      this.setState({
        route: _r
      })
    }

    resetRoute = () => {

      let _r = {
        _id: '100',
        truck: '',
        from: {
            address: '',
            name: '',
            lat: 0,
            lng: 0
        },
        to: {
            company: '',
            address: '',
            name: '',
            lat: 0,
            lng: 0
        },
        startDate: new Date(),
        endDate: new Date(),
        km: 0,
        revenue: 0,
        selected: false,
        drive: 0,
        duty: 0,
        off:0,
        berth: 0,
        time: 0,
        fuel: 0,
        tolls: 0,
        vectorPath: [],
        polyline: null
      };

      return _r

    }

    constructor(props) {
      super(props);
      this.state = {
          route: this.resetRoute(),
          routeList: [],
          showModal: false
        }
    }

    closeAddressBook = () => {
      this.setState({ showModal: false });
    }

    openAddressBook = () => {
      this.setState({ showModal: true });
    }


    updateFromLocation = (e) => {
      //console.log(e.target.value);
      let _r = this.state.route;
      _r.from.address = e.target.value;
      this.setState({route: _r});
    }

    updateToLocation = (e) => {
      //console.log(e.target.value);
      let _r = this.state.route;
      _r.to.address = e.target.value;
      this.setState({route: _r});
    }

    updateFromCompany = (e) => {
      //console.log(e.target.value);
      let _r = this.state.route;
      _r.from.name = e.target.value;
      this.setState({route: _r});
    }

    updateToCompany = (e) => {
      //console.log(e.target.value);
      let _r = this.state.route;
      _r.to.name = e.target.value;
      this.setState({route: _r});
    }

    updateFromCoordinates = (e) => {
      if (e.target.value.trim().length>0) {
        //console.log("update from coordinates...");

        fetch('https://api.mapbox.com/geocoding/v5/mapbox.places/'+ e.target.value +'.json?access_token='+process.env.REACT_APP_MAPBOX_API_KEY)
        .then((response) => {
          return response.json();
        }).then((json) => {
          //console.log(json);
          if (json.features.length > 0) {
            let _r = this.state.route;
            _r.from.lat = json.features[0].center[1];
            _r.from.lng = json.features[0].center[0];
            this.setState({route: _r});
          } else {
            //Nessun riscontro mapbox
            toastr.error('Error during city location');
          }

        });
      }
    }

    updateToCoordinates = (e) => {
      if (e.target.value.trim().length>0) {
        //console.log("update to coordinates...");

        fetch('https://api.mapbox.com/geocoding/v5/mapbox.places/'+ e.target.value +'.json?access_token='+process.env.REACT_APP_MAPBOX_API_KEY)
        .then((response) => {
          return response.json();
        }).then((json) => {
          //console.log(json);
          if (json.features.length > 0) {
            let _r = this.state.route;
            _r.to.lat = json.features[0].center[1];
            _r.to.lng = json.features[0].center[0];
            this.setState({route: _r});
          } else {
            toastr.error('Error during city location');
          }
        });
      }

    }


    updateMapRoute = (e) => {
        //console.log("update route...");
        fetch('https://api.mapbox.com/directions/v5/mapbox/driving/'+this.state.route.from.lng+','+this.state.route.from.lat+';'+this.state.route.to.lng+','+this.state.route.to.lat+'?overview=full&geometries=geojson&access_token='+process.env.REACT_APP_MAPBOX_API_KEY)
        .then((response) => {
          return response.json();
        }).then((json) => {
          //console.log(json);
          let _r = this.state.route;

          if (json.routes.length > 0) {
              _r.km = Math.round(json.routes[0].distance / 1600); // im miglia....
              _r.time = Math.round(json.routes[0].duration / 3600) ;
              _r.revenue = Math.round(_r.km * 2.07);
              _r.endDate.setHours(_r.endDate.getHours() + Math.floor(_r.time))

              _r.vectorPath = json.routes[0].geometry.coordinates;

              //console.log(JSON.stringify(_r.vectorPath));

              _r.vectorPath.map((vpath) => {
                vpath.reverse();
                return null;
              });

          } else {
              _r.vectorPath = [];
          }

          //_r.revenue= Math.round(Math.random()*500)
          _r.drive= Math.round(Math.random()*10)
          _r.duty= Math.round(Math.random()*10)
          _r.off= Math.round(Math.random()*10)
          _r.berth= Math.round(Math.random()*10)
          _r.fuel= Math.round(Math.random()*10)
          _r.tolls= Math.round(Math.random()*100)
          _r.truck = ((Math.round(Math.random() * 10) % 3)+1).toString();

          //console.log(_r);

          this.setState({
            route: _r,
            routeList: json.routes
          });


        });
    }


    onChangeView = (e) => {

      this.props.history.push('/'+e);
    }


    render() {
        return(
            <div>
            <HeaderBar onChangeView={this.onChangeView} actualPosition={"Shipper RFQ"}></HeaderBar>
              <Row className="gray-bg">
                <Col xs={7} sm={7} md={7} lg={7} >
                  <span className="top-spacer"></span>
                  <CollapsablePanel title="Request For Quote">

                    <Col xs={6} sm={6} md={6} lg={6} >
                      <div className="from-form">
                      <Label bsStyle="danger">Origin</Label>
                      <button className="btn btn-circle btn-xs pull-right" type="button" onClick={this.openAddressBook}><i className="fa fa-plus"></i></button>
                      <hr/>
                      <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={2}>
                          Zip
                        </Col>
                        <Col sm={10}>
                          <FormControl type="text" placeholder="Zip code" onChange={this.updateFromCompany} value={this.state.route.from.name}/>
                        </Col>
                      </FormGroup>
                      <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={2}>
                          City
                        </Col>
                        <Col sm={10}>
                          <FormControl type="text" placeholder="City" value={this.state.route.from.address} onChange={this.updateFromLocation} onBlur={this.updateFromCoordinates}/>
                        </Col>
                      </FormGroup>
                      <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={2}>
                          State
                        </Col>
                        <Col sm={10}>
                          <FormControl type="text" placeholder="State"  />
                        </Col>
                      </FormGroup>

                      </div>
                    </Col>

                    <Col xs={6} sm={6} md={6} lg={6} >
                      <div className="to-form">
                      <Label bsStyle="danger">Destination</Label>
                      <button className="btn btn-circle btn-xs pull-right" type="button" onClick={this.openAddressBook}><i className="fa fa-plus"></i></button>
                      <hr/>
                      <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={2}>
                          Zip
                        </Col>
                        <Col sm={10}>
                          <FormControl type="text" placeholder="Zip code" onChange={this.updateToCompany} value={this.state.route.to.name}/>
                        </Col>
                      </FormGroup>
                      <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={2}>
                          City
                        </Col>
                        <Col sm={10}>
                          <FormControl type="text" placeholder="City" value={this.state.route.to.address} onChange={this.updateToLocation} onBlur={this.updateToCoordinates}/>
                        </Col>
                      </FormGroup>
                      <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={2}>
                          State
                        </Col>
                        <Col sm={10}>
                          <FormControl type="text" placeholder="State" />
                        </Col>
                      </FormGroup>

                      </div>
                    </Col>

                    <Col xs={12} sm={12} md={12} lg={12} >
                        <hr/>
                        <Button type="button" bsSize="small" className="btn full-width btn-outline btn-danger btn-sm" onClick={this.updateMapRoute}>Generate Route</Button>

                        <div className="shipment-form">
                        <Label bsStyle="danger">Shipment Data</Label><br />
                        <hr/>
                        <ButtonGroup>
                          <Button bsSize="small">Route Info</Button>
                          <Button bsSize="small">Content</Button>
                          <Button bsSize="small">Documents</Button>
                        </ButtonGroup>

                        <FormGroup controlId="formHorizontalEmail">
                          <Col componentClass={ControlLabel} sm={2}>
                            Cargo Type
                          </Col>
                          <Col sm={10}>
                            <FormControl type="text" placeholder="Cargo Type"  />
                          </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                          <Col componentClass={ControlLabel} sm={2}>
                            Packaging
                          </Col>
                          <Col sm={10}>
                            <FormControl type="text" placeholder="Packaging" />
                          </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                          <Col componentClass={ControlLabel} sm={2}>
                            Equipment Needed
                          </Col>
                          <Col sm={10}>
                            <FormControl type="textg" placeholder="Equipment Needed" />
                          </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                          <Col componentClass={ControlLabel} sm={2}>
                            Weight
                          </Col>
                          <Col sm={10}>
                            <FormControl type="text" placeholder="Weight" />
                          </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                          <Col componentClass={ControlLabel} sm={2}>
                            Dimensions
                          </Col>
                          <Col sm={10}>
                            <FormControl type="text" placeholder="Dimensions" />
                          </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                          <Col componentClass={ControlLabel} sm={2}>
                            Special Instrunctions
                          </Col>
                          <Col sm={10}>
                            <FormControl type="text" placeholder="Special Instrunctions" />
                          </Col>
                        </FormGroup>
                        <FormGroup controlId="formHorizontalEmail">
                          <Col componentClass={ControlLabel} sm={2}>
                            Handling Instructions
                          </Col>
                          <Col sm={10}>
                            <FormControl type="text" placeholder="Handling Instructions" />
                          </Col>
                        </FormGroup>
                        </div>
                        <hr />
                    </Col>




                  <button className="btn btn-danger full-width" onClick={this.addRouteToList}>Submit RFQ</button>
                  <div className="clearfix"></div>
                  </CollapsablePanel>
                </Col>


                <Col xs={5} sm={5} md={5} lg={5} >
                    <span className="top-spacer"></span>
                    <CollapsablePanel title="Map">
                      <MapCreatorPanel routesList={[]} route={this.state.route} onRouteSelect={this.onRouteSelect}></MapCreatorPanel>
                    </CollapsablePanel>
                    <CollapsablePanel title="Summary">
                      From: <strong>{this.state.route.from.address? this.state.route.from.address: ''}</strong><br />
                      To: <strong>{this.state.route.to.address? this.state.route.to.address: ''}</strong><br />
                      Distance: <strong>{this.state.route.km} mi</strong><br />
                      Time: <strong>{this.state.route.time} hr</strong><br />
                      Average Cost: <strong>$ {this.state.route.revenue} </strong><br />
                      {/*Fuel: <strong>{this.state.route.fuel}</strong><br />*/}
                      {/*Tolls: <strong>{this.state.route.tolls}</strong><br />*/}
                    </CollapsablePanel>

                </Col>
            </Row>

            <Modal show={this.state.showModal} onHide={this.closeAddressBook}>
              <Modal.Header closeButton>
                <Modal.Title>Address Book</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ContactList></ContactList>
                <div className="clearfix" />
              </Modal.Body>
              <Modal.Footer>

              </Modal.Footer>
            </Modal>

            </div>
            );
    }
}
;



// WEBPACK FOOTER //
// ./src/pages/LogisticCreator.js